import React from 'react';
import style from './LinkButton.module.css';
import ArrowRight from "../../assets/svg/ArrowRight";

function LinkButton({children, url, ...props}) {

    return (
        <button
            onClick={() => window.open(url, '_blank')}
            className={style.main}
            {...props}
        >
            <div>
                {children}
            </div>

            <ArrowRight />
        </button>
    );
}

export default LinkButton;